import { getAppConfig } from '../../constants/appConfig';

const buildAuthorizeUrl = ({ gotoUrl, email, isFederated }) => {
  const authorizeUrl = new URL(gotoUrl);

  authorizeUrl.searchParams.set("login_hint", email);
  const domainHint = !isFederated ? getAppConfig().REACT_APP_NON_FED_DOMAIN_HINT : null;
  
  if (domainHint) {
    authorizeUrl.searchParams.set("domain_hint", domainHint);
  } else {
    authorizeUrl.searchParams.delete("domain_hint");
  }
  return authorizeUrl.toString();
};

export default buildAuthorizeUrl;